import ModuleView from "@/components/shieldx/ModuleView";
import { HeartPulse } from "lucide-react";

export default function SelfHealing() {
  return <ModuleView name="self-healing" icon={HeartPulse} />;
}
